import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getMarcas, createMarca, updateMarcaById, deleteMarcaById } from "../api";

const FilterTableMarca = () => {
  const [Marcas, setMarcas] = useState([]);
  const [filteredMarcas, setFilteredMarcas] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchMarcas = async () => {
    try {
      const response = await getMarcas();
      setMarcas(response.data);
      setFilteredMarcas(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching marcas:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchMarcas();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = Marcas.filter((Marca) =>
        Marca.descripcion.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredMarcas(filtered);
    } else {
      setFilteredMarcas(Marcas);
    }
  }, [filterText, Marcas]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateMarcaById(formData.id, { descripcion: formData.descripcion });
        alert("Marca actualizado con éxito.");
      } else {
        await createMarca(formData);
        alert("Marca registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "" });
      setIsEditing(false);
      fetchMarcas();
    } catch (error) {
      console.error("Error procesando el marca:", error);
    }
  };

  const handleEdit = (Marca) => {
    setFormData(Marca);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar esta marca?")) {
      try {
        await deleteMarcaById(id);
        alert("Marca eliminado con éxito.");
        fetchMarcas();
      } catch (error) {
        console.error("Error eliminando la marca:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Marca" : "Agregar Marca"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label3">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-2"
          />
        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por descripción..."
          className="input2"
        />
      </div>
      {filteredMarcas.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th colSpan="2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredMarcas.map((Marca) => (
              <tr key={Marca.id}>
                <td>{Marca.id}</td>
                <td>{Marca.descripcion}</td>
                <td>
                  <button onClick={() => handleEdit(Marca)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(Marca.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableMarca.propTypes = {
  marca: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableMarca;
